import React from "react";

import styled from "styled-components";

import { AutomationCommandProps } from "../types/automation";
import { GoToMapPayload } from "../types/payloads";

const GoToMapCommand: React.FC<AutomationCommandProps> = (props) => {
  const payload = props.command.payload as GoToMapPayload;
  return (
    <RootContainer>
      {payload?.location ? (
        <div>
          Go To{" "}
          <strong>
            ({payload.location[0].toFixed(2)}, {payload.location[1].toFixed(2)})
          </strong>{" "}
          at <strong>{payload.zoom?.toFixed(2)} </strong> zoom
        </div>
      ) : (
        <div>No Location Specified</div>
      )}
    </RootContainer>
  );
};

export default GoToMapCommand;

const RootContainer = styled.div``;
